export const slugify = (string: string) => {
	const newText = string
		.toLowerCase()
		.replace(/ /g, "-")
		.replace(/[^\w-]+/g, "");

	return newText;
};
